<template>
    <div id="app" class="app" v-if="firstLoading">
        <router-view />
        <preview ref="preview" :type="'normal'" />
        <upgrade :isAd="isAd" />
        <BuyFrame v-if="showBuyframe" @closeBuyFrame="closeBuyFrame" />
        <BuyDiscount v-model="showBuyDiscount" />
        <BuyPackage v-model="showBuyPackage" />
        <pay v-if="userInfo && userInfo.islogin" ref="pay" />
        <!-- 浏览器兼容提示 -->
        <component :is="'CompatibilityTips'" :Remindtype="1" v-if="showRemind" />
        <UserInfo />
        <dialogMask />
        <component :is="'importModal'" v-if="showImportModal" />
        <component :is="'limitFileModal'" v-if="showLimitFileModal" />
        <component :is="'teamsAppLeftPanel'" v-if="showLeftPanel" />
        <component :is="dialogType" v-if="showDialog"></component>
        <collectModal />

        <div class="open-files-box" v-if="showOpenFilesDialog">
            <div class="open-files-mask" :class="{ noMask: isPC }"></div>
            <div class="open-files-dialog">
                <p>{{ $t("openFilesTips") }}</p>
                <div class="open-files-btn">
                    <div class="open-files-cancel" @click="openFilesBtn(0)">{{ $t("cancel") }}</div>
                    <div class="open-files-confirm" @click="openFilesBtn(1)">{{ $t("confirm") }}</div>
                </div>
            </div>
        </div>

        <!-- <AD :adType="'alert'"/> -->
        <component :is="useAD" :adType="'alert'"></component>

        <div class="adbox-alert" v-if="buy618 && !vipState && isPC && internal">
            <div class="position-relative">
                <img class="close-icons" src="@/home/assets/img/2021-618-close.png" @click="closeBuy" alt="" />
                <img style="cursor: unset" src="@/home/assets/img/2021-618-bg.png" alt="" />
                <div class="buy-btn" @click="toBuy">
                    <img style="cursor: unset" src="@/home/assets/img/buy-btn.png" alt="" />
                </div>
            </div>
        </div>
        <Modal
            v-if="!isPrivate"
            v-model="showReleasesModal"
            :title="$t('function2')"
            :width="640"
            :footer-hide="true"
            :class-name="`releases-modal ${internal && 'internal'}`"
            :styles="{ top: 'auto' }"
            @on-visible-change="closeReleases"
        >
            <div v-if="showReleasesModal">
                <div style="position: relative" v-if="internal">
                    <div class="releases-content ztext" v-html="releasesContent"></div>
                    <Spin size="large" fix v-if="!releasesContent"></Spin>
                </div>
                <div v-if="!internal">
                    <iframe
                        height="600"
                        src="https://edrawmax.wondershare.com/whats-new.html?uplog=true"
                        frameborder="0"
                        style="width: 100%"
                    ></iframe>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="showVideoModal"
            :title="videoTitle"
            :width="700"
            :footer-hide="true"
            class-name="vertical-center-modal"
            @on-visible-change="videoModalChange"
        >
            <video :src="videoSrc" autoplay controls width="660" height="400"></video>
        </Modal>

        <!-- <Coupon /> -->
        <component :is="useCoupon"></component>

        <div class="fileopen-mask" v-if="pcLock">
            <img :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
        </div>
        <component :is="'BindPhone'" v-if="showBindPhone" />
        <miniprogram />
        <PromotionBox />
        <component :is="'MsgBox'" v-if="showMsg" />
        <credit />
        <component :is="'ReadOnlyModal'" v-if="showReadOnlyModal" />
        <NalPromo :from="'home'" v-if="$store.state.publicStore.nalPromoLoaded" />
        <Promodal v-if="showPromodal" :type="promodalType" :page="promodalPage" @togglePromodal="togglePromodal" />
        <PreviewModal v-if="showPreviewModal" />
        <UserTagModal v-if="showUserTag" />
        <CollectTips v-if="showCollectTips" @closeCollectModal="closeCollectModal" />
        <GlobalNotice :from="'home'" />
    </div>
</template>

<script lang="ts">
    declare var app: any;
    declare var $edAuth: any;
    import { EDRAWMAX_USE_AD, EDRAWMAX_USE_COUPON, EDRAWMAX_WXREDIRECT } from "@/env/";
    import appConfig from "@/public/globalConfig";
    import UserInfo from "./parts/Tpl/tplUserWorks.vue";
    import preview from "./parts/Tpl/tplPreview.vue";
    import pay from "./parts/Tpl/tplPay.vue";
    import collectModal from "./parts/Tpl/alert/collectModal.vue";
    import Cookies from "js-cookie";
    import axios from "axios";
    import { Component, Prop, Provide, Vue, Watch, Mixins } from "vue-property-decorator";
    import upgrade from "@/public/components/upgrade.vue";
    import BuyFrame from "@/public/components/buyFrame.vue";
    import BuyDiscount from "@/public/components/BuyDiscount.vue";
    import BuyPackage from "@/public/components/BuyPackage.vue";
    import Feedback from "./parts/feedback.vue";
    import dialogMask from "./parts/dialogMask.vue";
    import { logout, validate, refreshToken, setCookie } from "@/public/utils/auth";
    import { isValidJSON } from "@/public/utils/tool.js";
    import miniprogram from "@/home/parts/miniprogram.vue";
    import Hotkey from "@/app/components/Modals/Hotkey.vue";
    import credit from "@/home/parts/credit/credit.vue";
    import PromotionBox from "@/public/components/PromotionBox.vue";
    import { isPwa } from "@/home/main";
    import NalPromo from "@/public/components/NalPromo.vue";
    import GlobalNotice from "@/public/components/GlobalNotice/index.vue";
    import * as Sentry from "@sentry/vue";

    function fibonacciDelay(retryCount) {
        const maxDelay = 30000; // 最大延迟时间为 30 秒
        const delay = Math.min(Math.pow(2, retryCount) * 1000, maxDelay);
        return delay;
    }

    function delayFunc(delay) {
        return new Promise((resolve) => setTimeout(resolve, delay));
    }
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            upgrade,
            BuyFrame,
            BuyDiscount,
            BuyPackage,
            UserInfo,
            preview,
            pay,
            collectModal,
            importModal: () => import("./parts/ImportModal.vue"),
            limitFileModal: () => import("./parts/limitFileModal.vue"),
            Feedback: () => import("./parts/feedback.vue"),
            dialogMask,
            BindPhone: () => import("../app/components/Modals/BindPhone.vue"),
            CompatibilityTips: () => import("@/public/components/compatibilityTips.vue"),
            miniprogram,
            MsgBox: () => import("@/home/parts/MsgBox.vue"),
            Hotkey,
            teamsAppLeftPanel: () => import("@/home/parts/teamsAppLeftPanel.vue"),
            credit,
            ReadOnlyModal: () => import("@/home/parts/vip/ReadOnlyModal.vue"),
            PromotionBox,
            NalPromo,
            GlobalNotice,
            TemplateModal: () => import("@/home/parts/onlineView/parts/templateModal.vue"),
            Promodal: () => import("@/public/components/Promodal.vue"),
            PreviewModal: () => import("@/home/parts/Tpl/alert/previewModal.vue"),
            UserTagModal: () => import("@/home/parts/UserTagModal.vue"),
            CollectTips: () => import("@/home/parts/CollectTips.vue"),
        },
    })
    export default class UserApp extends Vue {
        // showLogin = false;
        showRemind = false;
        firstLoading = false;
        closeBtn: any = require("@/home/assets/img/fullscreen-close.png");
        tryLoginDone: boolean = false;
        oldLang: string = "";
        allowLangList = ["zh", "en", "de", "fr", "jp", "es", "pt", "it", "tw", "kr", "id", "ru"];
        retryCount: number = 0;
        delay: number = 0;

        get useAD() {
            return EDRAWMAX_USE_AD ? () => import("@/home/parts/activity/AD.vue") : null;
        }
        get useCoupon() {
            return EDRAWMAX_USE_COUPON ? () => import("@/home/parts/coupon.vue") : null;
        }

        countDownTimer = null;
        @Watch("$route", { immediate: true })
        changeLang(nv, ov) {
            if (nv.params && nv.params.lang) {
                let lang = nv.params.lang;
                if (this.allowLangList.includes(lang) && lang != this.oldLang) {
                    this.oldLang = lang;
                    this.setLang(lang, true);
                }
            }
        }
        // 不兼容提示
        closeRemind() {
            this.showRemind = false;
            this.showNewGuidanceVideo();
        }

        openFilesBtn(status) {
            this.showOpenFilesDialog = false;
            this.$bus.$emit("openFilesConfirm", status);
        }
        get showBindPhone() {
            return this.$store.state.bindPhoneDialog.showBingPhoneDialog;
        }
        get pcLock() {
            return this.$store.state.pcLockStatus;
        }
        get showLeftPanel() {
            return this.$store.state.showLeftPanel;
        }
        get showReleasesModal() {
            return this.$store.state.showReleasesModal;
        }
        set showReleasesModal(val: boolean) {
            this.$store.commit("setState", {
                type: "showReleasesModal",
                data: val,
            });
        }
        releasesContent = "";
        releasesVersion = "";
        get isAd() {
            return this.$store.state.isAd;
        }
        get showVideoModal() {
            return this.$store.state.showVideoModal;
        }
        set showVideoModal(v) {
            this.$store.commit("setState", {
                type: "showVideoModal",
                data: v,
            });
        }
        get videoTitle() {
            return this.$store.state.videoTitle;
        }
        get videoSrc() {
            return this.$store.state.videoSrc;
        }
        get showOpenFilesDialog() {
            return this.$store.state.showOpenFilesDialog;
        }
        set showOpenFilesDialog(v) {
            this.$store.commit("setState", {
                type: "showOpenFilesDialog",
                data: v,
            });
        }

        get buy618() {
            return this.$store.state.buy618;
        }
        get downloadUrl() {
            return this.internal ? "https://www.google.cn/chrome/" : "https://www.google.com/chrome/";
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get showImportModal() {
            return this.$store.state.showImportModal;
        }
        get showLimitFileModal() {
            return this.$store.state.showLimitFileModal;
        }
        get showReadOnlyModal() {
            return this.$store.state.showReadOnlyModal;
        }
        get pcLang() {
            return this.$store.state.pcLang;
        }
        set pcLang(v) {
            this.$store.commit("setState", {
                type: "pcLang",
                data: v,
            });
        }

        get showDialog() {
            return this.$store.state.showDialog;
        }
        get dialogType() {
            return this.$store.state.dialogType;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        afterUserTask = true; // 入门视频延迟至新手任务后触发
        // 是否展示新功能指引视频
        showNewGuidanceVideo() {
            if (this.isWorkwx || this.isTeamsApp) return;
            const isNew = this.$store.state.starter !== null && (this.$store.state.starter & 1) !== 1;
            // this.internal && this.initReleases(isNew);
            // 海外只要是新用户和全量发布，就主动弹窗更新日志
            if (false && !this.internal) {
                // 海外临时关闭版本更新日志
                axios
                    .get("https://www.edrawmax.com/public/whats-new/online_version.json", {
                        responseType: "json",
                    })
                    .then((res: any) => {
                        let version = res.data.version;
                        const localVision = localStorage.getItem("appVersion");
                        if (!localVision || localVision !== version) {
                            this.showReleasesModal = true;
                            localStorage.setItem("appVersion", version);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            this.$store.commit("setState", {
                type: "isNewUser",
                data: isNew,
            });
            if (isNew) {
                if (appConfig.language == "zh") {
                    // setTimeout(()=>{
                    //     this.$bus.$emit("starterGuide");
                    // },1000)
                    let updateStarter = () => {
                        let ts = this;
                        if (ts.$store.state.starter !== null) {
                            if (ts.userInfo) {
                                let params = {
                                    id: ts.userInfo.user_id,
                                    token: ts.userInfo.token,
                                    obj: { starter: ts.$store.state.starter | 1 },
                                };
                                ts.$edApi.updateUserPrefer(params);
                            }
                        }
                    };
                    // 新用户显示入门视频
                    let showVideo = () => {
                        let item = this.$store.state.newUserVideo;
                        let play = () => {
                            item = this.$store.state.newUserVideo;
                            this.$store.commit("playVideo", {
                                title: item.title,
                                src: item.attach,
                            });
                        };
                        if (item) {
                            play();
                        } else {
                            this.$edApi
                                .getVideo({
                                    class_id: 4,
                                    user_id: 0,
                                    platform: 1,
                                    product: 2,
                                })
                                .then((list) => {
                                    this.$store.commit("setState", {
                                        type: "newUserVideo",
                                        data: list.filter((v) => v.title == "入门视频")[0],
                                    });
                                    play();
                                });
                        }
                    };
                    if (this.afterUserTask) {
                        this.$bus.$on("getUserTaskDone", () => {
                            this.$bus.$off("getUserTaskDone");
                            showVideo();
                            updateStarter();
                        });
                    } else {
                        showVideo();
                        updateStarter();
                    }
                }
            }
        }
        init() {
            console.log(navigator.userAgent);
            if (this.userInfo && this.userInfo.islogin) {
                this.$store.dispatch("getUserInfo").catch((e) => {
                    console.log("token err" + JSON.stringify(e));
                });
            }
            if (this.userInfo) {
                if (this.isPC) {
                    this.setLang(this.pcLang, true);
                } else if (this.userInfo.islogin) {
                    let lang = "";
                    this.$edApi.getUserPrefer({ id: this.userInfo.user_id }).then((e) => {
                        if (!this.isPC) {
                            this.$store.commit("setState", {
                                type: "starter",
                                data: e?.data?.starter,
                            });
                            // 是chrome浏览器,不展示浏览器兼容弹窗,之间展示新功能
                            if (!this.showRemind) {
                                this.showNewGuidanceVideo();
                            }
                        }
                        if (e?.data?.language) {
                            lang = e.data.language;
                        }
                        if (this.oldLang && !this.internal) {
                            // 海外未登录前通过 url 直接拿到的 lang 登录后还是对应的 lang
                            lang = this.oldLang;
                        }
                        this.setLang(lang);
                        this.$store.commit("setState", {
                            type: "initLang",
                            data: true,
                        });
                        this.firstSetLang && this.firstSetLang();
                    });
                }
            }
        }
        firstSetLang() {
            this.$bus.$emit("firstSetLang");
            this.firstSetLang = null;
        }

        setLang(item, noSet: boolean = false) {
            console.log("-------lang", item);
            // url上的语言为准，用户切换语言后更新url上lang参数,同时上传至用户偏好(用于编辑页语言)
            let change = () => {
                let routeList = [
                    "/New",
                    "/files",
                    "/teams",
                    "/dropbox",
                    "/share",
                    "/newPage",
                    "/store",
                    "/recycle",
                    "/collect",
                    "/workbench",
                    "/publishFile",
                    "/historyView",
                    "/pcShare",
                    "/pcFile",
                    "/pcFile",
                    "/tagsbox",
                ];
                if (routeList.includes(this.$route.path)) {
                    this.$router
                        .replace({
                            params: { lang: item },
                            path: `/${item}${this.$route.path}`,
                            query: this.$route.query,
                        })
                        .catch((err) => {});
                } else {
                    this.$router
                        .replace({
                            params: { lang: item },
                            query: this.$route.query,
                        })
                        .catch((err) => {});
                }
                this.$store.commit("changeUILang", item);
                this.$bus.$emit("changeLangDone");
                localStorage.setItem("lang", item);
            };
            if (noSet) {
                change();
            } else {
                this.$store
                    .dispatch("setLang", { lang: item })
                    .then((res) => {
                        change();
                    })
                    .catch((e) => {});
            }
        }
        getToken(name) {
            var cArr = document.cookie.split(";");
            var tok;
            var cName = name + "=";
            if (document.cookie) {
                cArr.forEach(function (t) {
                    var m = t.trim();
                    if (m.indexOf(cName) === 0) {
                        tok = m.slice(cName.length);
                    }
                });
            }
            return tok || undefined;
        }
        initInclowdzEvent(firstLoad = false) {
            let checkLog = () => {
                this.firstLoading = true;
                window.parent.postMessage(
                    {
                        mode: "iframe2parent_need_response",
                        target: "user",
                        action: "get_token",
                        type: "request",
                        session_id: "0000000001",
                        version: "v1",
                        data: "",
                    },
                    "*"
                );
            };
            let toLogin = (access_token) => {
                // 登录获取用户信息
                this.$edApi
                    .getAccessToken({
                        access_token: access_token,
                        lang: this.lang == "zh" ? "CN" : this.lang.toUpperCase(),
                    })
                    .then((e) => {
                        console.log(e);
                        e.data.oldInfo = true;
                        e.data.islogin = true;
                        this.$store.commit("setState", { type: "userInfo", data: e.data });
                        sessionStorage.setItem("userInfo", JSON.stringify(e.data));
                        this.firstLoading = true;
                        this.init();
                        this.$bus.$emit("loginSucc");
                        loadingDone();
                    });
            };
            let toLogout = () => {
                // 退出清除用户信息
                sessionStorage.setItem("userInfo", "");
                location.reload();
            };
            let loadingDone = () => {
                window.parent.postMessage(
                    {
                        mode: "iframe2parent",
                        target: "loading",
                        action: "completed",
                        type: "request",
                        session_id: "0000000004",
                        version: "v1",
                        data: "",
                    },
                    "*"
                );
            };
            // func
            let importFile = (data) => {
                // 接受文件url，下载文本并调用import文件流程
                console.log("import file", data);
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.$edApi.downloadInclowdzFile(data.download_url).then((e) => {
                    console.log(e);
                    this.$bus.$emit("importInclowdzFile", new File([e], data.filename));
                });
            };
            let downloadFile = (data) => {
                // 下载eddx文件
                window.parent.postMessage(
                    {
                        mode: "iframe2parent",
                        target: "file",
                        action: "export",
                        type: "request",
                        session_id: "0000000003",
                        version: "v1",
                        data: {
                            filename: data.name,
                            filesize: data.size,
                            download_url: data.url,
                        },
                    },
                    "*"
                );
            };
            if (firstLoad) {
                window.addEventListener("message", (message: any) => {
                    let msg: any = message.data;
                    if (msg.mode == "iframe2parent_need_response" && msg.version == "v1") {
                        if (msg.action == "login_success") {
                            toLogin(msg.data.access_token);
                        } else if (msg.action == "get_token") {
                            toLogin(msg.data.token);
                        }
                    } else if (msg.mode == "parent2iframe" && msg.version == "v1") {
                        if (msg.action == "update_token") {
                            // toLogin(msg.data.token); // 暂不需要处理
                        } else if (msg.action == "logout") {
                            toLogout();
                        } else if (msg.action == "edit") {
                            importFile(msg.data);
                        }
                    }
                });

                this.$bus.$on("inclowdz_download", downloadFile);
            }
            checkLog();
        }
        checkUrlToken(callback) {
            let params = new URLSearchParams(location.search);
            let custom: string = params.get("custom") || "";
            if (custom && custom != "null") {
                history.replaceState(history.state, "", location.href.replace(/[\&|\?]custom\=[^\&]*/, ""));
                this.$router
                    .replace({
                        query: null,
                    })
                    .catch((err) => {});
                let tempStr = atob(custom);
                let valid = isValidJSON(tempStr);
                if (!valid) return false;
                let obj = JSON.parse(tempStr);
                if (obj.id == 0) return false;
                this.$edApi.getUserInfo(obj).then((e: any) => {
                    if (e && e.data) {
                        e.data.token = obj.token;
                        e.data.refresh_token = obj.refreshToken || "";
                        e.data.islogin = true;
                        callback(e.data);
                        // set cookie
                        let exp = e.data.token.split(".")[1];
                        exp = JSON.parse(window.atob(exp)).exp;
                        let expDate = new Date(exp * 1000);
                        document.cookie = `EDCurrent=${encodeURIComponent(JSON.stringify(e.data))};expires=${expDate};path=/`;
                        $edAuth.rewriteToken(`custom=${btoa(encodeURIComponent(JSON.stringify(e.data)))}`);
                    }
                });
                return true;
            }
            return false;
        }
        refreshCallback() {
            let ts = this;
            refreshToken.setCallback(
                (accessToken) => {
                    console.log(ts.firstLoading, accessToken);
                    let userInfo = { ...ts.userInfo, token: accessToken };
                    ts.$store.commit("setState", {
                        type: "userInfo",
                        data: userInfo,
                    });
                },
                () => {
                    if (this.isWorkwx) {
                        location.href = EDRAWMAX_WXREDIRECT;
                    } else if (this.isPrivate) {
                        location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                    }
                }
            );
        }
        setLocalCookie() {
            if (this.isTeamsApp && this.userInfo?.token) {
                var exp = this.userInfo.token.split(".")[1];
                exp = JSON.parse(window.atob(exp)).exp;
                var expDate = new Date(exp * 1000);
                Cookies.set("EDCurrent", JSON.stringify(this.userInfo), {
                    expires: expDate,
                    path: "/",
                    sameSite: "None",
                    secure: true,
                });
            }
        }
        afterLogined() {
            const userInfo = this.userInfo;
            const checkLimitFileNum = () => {
                if (!userInfo.user_id || !userInfo.token) {
                    return;
                }

                this.$edApi
                    .getUserLimit({
                        id: userInfo.user_id,
                        token: userInfo.token,
                        platform: this.$store.state.publicStore.runPlatform,
                    })
                    .then((res) => {
                        let num = res.data.limit;
                        let convert_num = res.data.convert_num;
                        this.$store.commit("setState", {
                            type: "limitFileNum",
                            data: num,
                        });
                        this.$store.commit("setState", {
                            type: "visioLimit",
                            data: convert_num,
                        });
                        this.$store.commit("setState", {
                            type: "limitFileNowFileNum",
                            data: res.data.num,
                        });
                    });
            };
            checkLimitFileNum();
            !this.isPC && this.$store.dispatch("getNalPromo", { lang: this.lang, from: "home" });
            if (!this.isPC && this.internal && !this.vip) {
                this.$store.dispatch("getBuyModalCloseTimes");
            }
        }
        @Watch("lang")
        watchLang() {
            if (this.isPC || this.internal) return;
            if (!this.$validateLogin(false)) return;
            this.$store.dispatch("getNalPromo", { lang: this.lang, from: "home" }).then(() => {
                this.$bus.$emit("update_ad");
            });
        }
        get showBuyframe() {
            return this.$store.state.publicStore.showBuyframe;
        }
        set showBuyframe(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyframe",
                data: val,
            });
        }
        get showBuyDiscount() {
            return this.$store.state.publicStore.showBuyDiscount;
        }
        set showBuyDiscount(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyDiscount",
                data: val,
            });
        }
        get showBuyPackage() {
            return this.$store.state.publicStore.showBuyPackage;
        }
        set showBuyPackage(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyPackage",
                data: val,
            });
        }
        closeBuyFrame() {
            this.showBuyframe = false;
            //关闭弹窗时检查用户信息以更新vip状态
            this.updateVipStatus();
        }
        updateVipStatus() {
            if (this.isPlugin || this.isTeamsApp || this.isInclowdz || this.isPrivate) return;
            const vipTrigger = this.$store.state.publicStore.upgradeTrigger;
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "",
            });
            // 重新获取vip信息
            this.$store
                .dispatch("updateVipStatus", {
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    if (vipTrigger) {
                        this.sensors.track("upgradePlanSuccess", {
                            Catalogues: "payPath",
                            upgrade_trigger: vipTrigger,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        checkLog() {
            if (this.isPlugin) {
                this.firstLoading = true;
                return;
            }
            if (this.isInclowdz) {
                this.initInclowdzEvent(true);
                return;
            }
            if (this.isWorkwx) {
                this.refreshCallback();
                validate()
                    .then((userInfo: any) => {
                        console.log("resolve", userInfo);
                        this.$store.commit("setState", {
                            type: "userInfo",
                            data: {
                                oldInfo: true,
                                islogin: true,
                                ...userInfo,
                            },
                        });
                        this.init();
                        this.$bus.$emit("loginSucc");
                        this.$bus.$emit("loginSucc-collect");
                        this.$bus.$emit("loginSucc-files");
                        this.$bus.$emit("loginSucc-newpages");
                        this.$bus.$emit("loginSucc-recycle");
                        this.$bus.$emit("loginSucc-share");
                        this.$bus.$emit("loginSucc-store");
                        this.$bus.$emit("loginSucc-history");
                        this.$bus.$emit("loginSucc-publish");
                        this.$bus.$emit("loginSucc-shareToMe");
                        this.$bus.$emit("loginSucc-star");
                        this.$bus.$emit("loginSucc-team");
                        this.$bus.$emit("loginSucc-preview");
                        this.tryLoginDone = true;
                        this.firstLoading = true;
                    })
                    .catch(() => {
                        // try login
                        console.log("reject");
                        // let testSearch = "?code=7FSn_EaYWSXPicjOTTo2tmOzKKf32sEcSc0UL1LdRHI&state=STATE"
                        // let urlParmas = new URLSearchParams(testSearch);
                        let urlParmas = new URLSearchParams(location.search.substr(1));
                        let code = urlParmas.get("code"),
                            state = urlParmas.get("state");
                        if (code) {
                            this.$edApi
                                .workwx_login({
                                    code,
                                    product: "edrawmax",
                                })
                                .then((e) => {
                                    console.log(e);
                                    let res = e.data;
                                    let userInfo = {
                                        oldInfo: true,
                                        islogin: true,
                                        token: res.access_token,
                                        ...res,
                                    };
                                    this.$store.commit("setState", {
                                        type: "userInfo",
                                        data: userInfo,
                                    });
                                    this.$edApi
                                        .getRole({
                                            user_id: userInfo.user_id,
                                        })
                                        .then((e) => {
                                            console.log(e);
                                            setCookie(userInfo);
                                            this.init();
                                            refreshToken.loginInterval(userInfo);
                                            this.$bus.$emit("loginSucc");
                                            this.$bus.$emit("loginSucc-collect");
                                            this.$bus.$emit("loginSucc-files");
                                            this.$bus.$emit("loginSucc-newpages");
                                            this.$bus.$emit("loginSucc-recycle");
                                            this.$bus.$emit("loginSucc-share");
                                            this.$bus.$emit("loginSucc-store");
                                            this.$bus.$emit("loginSucc-history");
                                            this.$bus.$emit("loginSucc-publish");
                                            this.$bus.$emit("loginSucc-shareToMe");
                                            this.$bus.$emit("loginSucc-star");
                                            this.$bus.$emit("loginSucc-team");
                                            this.$bus.$emit("loginSucc-preview");
                                            this.tryLoginDone = true;
                                            this.firstLoading = true;
                                        });
                                });
                        } else {
                            location.href = EDRAWMAX_WXREDIRECT;
                        }
                    });
                return;
            }
            if (this.isPrivate) {
                this.refreshCallback();
                validate()
                    .then((userInfo: any) => {
                        this.$store.commit("setState", {
                            type: "userInfo",
                            data: {
                                oldInfo: true,
                                islogin: true,
                                ...userInfo,
                            },
                        });
                        this.init();
                        this.$bus.$emit("loginSucc");
                        this.$bus.$emit("loginSucc-collect");
                        this.$bus.$emit("loginSucc-files");
                        this.$bus.$emit("loginSucc-newpages");
                        this.$bus.$emit("loginSucc-recycle");
                        this.$bus.$emit("loginSucc-share");
                        this.$bus.$emit("loginSucc-store");
                        this.$bus.$emit("loginSucc-history");
                        this.$bus.$emit("loginSucc-publish");
                        this.$bus.$emit("loginSucc-shareToMe");
                        this.$bus.$emit("loginSucc-star");
                        this.$bus.$emit("loginSucc-team");
                        this.$bus.$emit("loginSucc-preview");
                        this.$bus.$emit("loginSucc-userTask");
                        this.tryLoginDone = true;
                        this.firstLoading = true;
                    })
                    .catch(() => {
                        location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                    });
                return;
            }
            let payload;
            if (this.isPC) {
                //客户端
                payload = JSON.parse((<any>window).userData);
                let langList = this.allowLangList;
                if (langList.indexOf(payload.lang) < 0) {
                    payload.lang = appConfig.language;
                }
                this.pcLang = payload.lang;

                this.$store.commit("toPublicStatus", {
                    type: "runPlatform",
                    data: this.internal ? payload.platform : "pc",
                });
                this.$store.commit("toPublicStatus", {
                    type: "pid",
                    data: payload.pid,
                });

                // 7.2版本后会传递一个version字段过来
                // 老版本的英文站，提示客户端升级提醒
                let clientVersion = payload.version;
                console.log(")))))))))))))))))))))))))))))" + (<any>window).userData);

                this.$store.commit("toUserInfo", payload);
                this.$store.commit("setState", { type: "pcVersion", data: clientVersion });

                // --testOpenTemplate
                if (false && payload.testTemplate) {
                    this.$store.commit("setState", { type: "testOpenTemplate", data: true });
                }

                let theme = new URLSearchParams(location.search.substr(1)).get("theme");
                if (theme != null) {
                    localStorage.setItem("themeColor", theme);
                }

                let isfg = new URLSearchParams(location.search.substr(1)).get("fg"); // 毛玻璃主题
                if (isfg) {
                    window.document.documentElement.setAttribute("data-theme", "pc-fg");
                } else {
                    window.document.documentElement.setAttribute("data-theme", "pc-normal");
                }

                this.firstLoading = true;
                this.init();
                payload.islogin && this.$bus.$emit("loginSucc");
                this.afterLogined();
                this.sensors.registerPage({
                    uid: this.internal ? payload.user_id : (payload.ws_info ? payload.ws_info.ws_id : payload.ws && payload.ws.ws_id) || 0,
                });
                this.sensors.track("startIn", {
                    Catalogues: "Start",
                    platform: isPwa ? "pwa" : "web",
                });
            } else {
                window.document.documentElement.setAttribute("data-theme", "pc-normal");
                let success = (userInfo) => {
                    userInfo.oldInfo = true;
                    userInfo.islogin = true;
                    this.sensors.registerPage({
                        uid: this.internal ? userInfo.user_id : (userInfo.ws_info ? userInfo.ws_info.ws_id : userInfo.ws && userInfo.ws.ws_id) || 0,
                    });
                    let cleanAuthCode = () => {
                        let newQuery = {
                            ...this.$route.query,
                        };

                        if (Object.keys(newQuery).includes("auth_code")) {
                            delete newQuery.auth_code;
                            this.$router.replace({ query: newQuery });
                        }
                    };
                    let getVIPDone = () => {
                        this.$store.commit("setState", { type: "userInfo", data: userInfo });
                        this.checkUserTag(userInfo);
                        this.init();
                        this.setLocalCookie();
                        this.$bus.$emit("loginSucc");
                        this.$bus.$emit("loginSucc-collect");
                        this.$bus.$emit("loginSucc-files");
                        this.$bus.$emit("loginSucc-newpages");
                        this.$bus.$emit("loginSucc-recycle");
                        this.$bus.$emit("loginSucc-share");
                        this.$bus.$emit("loginSucc-store");
                        this.$bus.$emit("loginSucc-history");
                        this.$bus.$emit("loginSucc-publish");
                        this.$bus.$emit("loginSucc-shareToMe");
                        this.$bus.$emit("loginSucc-star");
                        this.$bus.$emit("loginSucc-team");
                        this.$bus.$emit("loginSucc-preview");
                        this.$bus.$emit("loginSucc-userTask");
                        this.tryLoginDone = true;
                        this.firstLoading = true;
                        this.$store.dispatch("getUserInfo").then((e) => {
                            let userInfo = e.data;
                            if (userInfo.seo_source) {
                                this.sensors.registerPage({
                                    seo_source: userInfo.seo_source,
                                });
                            }
                            if (userInfo.selfutm_term) {
                                this.sensors.registerPage({
                                    selfutm_term: userInfo.selfutm_term,
                                });
                            }
                            this.sensors.track("startIn", {
                                Catalogues: "Start",
                                platform: isPwa ? "pwa" : "web",
                            });
                            this.sensors.track("signInAll", {
                                Catalogues: "login",
                            });
                        });
                        this.afterLogined();
                    };
                    cleanAuthCode();
                    this.$edApi
                        .getSubscription({ id: userInfo.user_id, token: userInfo.token })
                        .then((expObj) => {
                            console.log(expObj);
                            const vipType = ["normal", "vip", "lifetimeVip", "vip expire"];
                            if (expObj) {
                                this.$store.commit("toPublicStatus", {
                                    type: "fuser",
                                    data: expObj.fuser ? 1 : 0,
                                });
                                let { now, online_exp: onlineExp, exp } = expObj,
                                    curStamp = new Date(now).getTime(),
                                    expStamp = new Date(this.isPC ? exp : onlineExp).getTime();

                                if (expStamp > curStamp) {
                                    this.$store.commit("toPublicStatus", { type: "vip", data: 1 });
                                    this.sensors.registerPage({
                                        userPayingType: "vip",
                                        is_vip: true,
                                        vip_type: expObj.fuser ? vipType[2] : vipType[1],
                                    });

                                    if (!app.hasOwnProperty("$v_")) {
                                        Object.defineProperty(app, "$v_", { value: 1 });
                                    }
                                } else {
                                    this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                                    this.getPurchaseBubble();
                                    if (!app.hasOwnProperty("$v_")) {
                                        Object.defineProperty(app, "$v_", { value: 0 });
                                    }
                                    this.sensors.registerPage({
                                        userPayingType: "vip expire",
                                        is_vip: false,
                                        vip_type: vipType[3],
                                    });
                                }
                            } else {
                                this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                                this.getPurchaseBubble();
                                if (!app.hasOwnProperty("$v_")) {
                                    Object.defineProperty(app, "$v_", { value: 0 });
                                }
                                this.sensors.registerPage({
                                    userPayingType: "no vip",
                                    is_vip: false,
                                    vip_type: vipType[0],
                                });
                            }
                            getVIPDone();
                        })
                        .catch((err) => {
                            console.log(err);
                            console.log(err.response);
                            this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                            if (!app.hasOwnProperty("$v_")) {
                                Object.defineProperty(app, "$v_", { value: 0 });
                            }
                            getVIPDone();
                        });
                };
                let fail = () => {
                    this.sensors.track("startIn", {
                        Catalogues: "Start",
                        platform: isPwa ? "pwa" : "web",
                    });
                    if (appConfig.isBuild && appConfig.loginRedirect && !this.isTeamsApp) {
                        const search = new URLSearchParams(location.search.slice(1));
                        if (!this.internal && search.get("notAuto")) {
                            location.href = `${location.origin}`;
                        } else {
                            location.href = `${location.origin}?auto=1`;
                        }
                    }
                    if (!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
                        $edAuth.show();
                    }

                    this.tryLoginDone = true;
                    this.$bus.$emit("failSucc");
                };
                if (this.checkUrlToken(success)) {
                    // 检查url是否带用户参数
                    return;
                }

                let utm_term = this.utm_term ? `4-${this.utm_term}` : "";
                let loginParams = {
                    pid: this.appPid,
                    seo_source: utm_term,
                    refreshMode: 1,
                };

                $edAuth
                    .checkLocalCookie(true, loginParams)
                    .then((userInfo: any) => {
                        success(userInfo);
                        if (userInfo && userInfo.user_id) {
                            Sentry.setUser({ id: userInfo.user_id });
                        }
                    })
                    .catch(() => {
                        this.firstLoading = true;
                        let lang = this.$route.params && this.$route.params.lang;
                        !lang && (lang = appConfig.language);

                        $edAuth.auth(success, fail, loginParams);
                    });
            }
        }
        checkProModal() {
            const local = localStorage.getItem("1272_pro");
            const list = local ? JSON.parse(local) : [];
            if (!this.internal && this.lang == "en" && !list.includes(this.userInfo.user_id) && !this.vip) {
                console.log("no vip");
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: "signInFirst",
                });
                this.togglePromodal(true);
                list.push(this.userInfo.user_id);
                localStorage.setItem("1272_pro", JSON.stringify(list));
            }
        }
        isBrowser() {
            // let agent = navigator.userAgent.toLowerCase()
            // let is360 = this.mime("type", "application/vnd.chromium.remoting-viewer")
            // if (is360) {
            //    this.showRemind = true;
            //     return
            // }
            // if(window.localStorage.getItem('remindCompatible') == '1'){
            //     return
            // }
            let userAgent = window.navigator.userAgent; //取得浏览器的userAgent字符串
            let browser = "unknown";
            if (userAgent.indexOf("IE") != -1) {
                //字符串含有IE字段，表明是IE浏览器
                browser = "IE";
            } else if (userAgent.indexOf("Firefox") != -1) {
                //字符串含有Firefox字段，表明是火狐浏览器
                browser = "Firefox";
            } else if (userAgent.indexOf("OPR") != -1) {
                //Opera
                browser = "Opera";
            } else if (
                userAgent.indexOf("Chrome") != -1 &&
                userAgent.indexOf("360SE") == -1 &&
                userAgent.indexOf("MetaSr") == -1 &&
                userAgent.indexOf("QQBrower") == -1
            ) {
                //Chrome
                browser = "Chrome";
            } else if (userAgent.indexOf("Safari") != -1) {
                //Safari
                browser = "Safari";
            } else if (userAgent.indexOf("Trident") != -1) {
                //IE内核
                browser = "IE 11";
            }
            // if(!(this.isPC || (<any>window).chrome && agent.indexOf('chrome') && agent.indexOf("edge") === -1)){
            //     this.showRemind = true;
            // }
            if (!this.isPC && !["Safari", "Chrome"].includes(browser)) {
                this.showRemind = true;
            }
        }
        mime(option, value) {
            let mimeTypes = navigator.mimeTypes;
            for (var mt in mimeTypes) {
                if (mimeTypes[mt][option] == value) {
                    return true;
                }
            }
            return false;
        }
        // upgrade
        setPublicStatus(data) {
            this.$store.commit("toPublicStatus", data);
        }
        checkBuyAction() {
            // 检查是否购买会员。是则刷新页面
            window.addEventListener("storage", (e) => {
                if (e.key == "buyAction" && e.newValue == "1") {
                    window.location.reload();
                }
            });
        }

        trackSignUp(userInfo) {
            if (userInfo.register == 1) {
                this.$store.commit("setState", { type: "userInfo", data: userInfo });
                this.$store.dispatch("getUserInfo").then((e) => {
                    let userInfo = e.data;
                    if (userInfo.seo_source) {
                        this.sensors.registerPage({
                            seo_source: userInfo.seo_source,
                        });
                    }
                    if (userInfo.selfutm_term) {
                        this.sensors.registerPage({
                            selfutm_term: userInfo.selfutm_term,
                        });
                    }
                    this.sensors.track("signUpSuccess", {
                        Catalogues: "Login",
                    });
                });
            }
        }

        // get domain(){
        //     return this.$store.state.domain;
        // }
        // set domain(v){
        //     this.$store.commit("setDomain",v);
        // }
        created() {
            if (this.isBoard) {
                let messageHandle = (msg) => {
                    let data = msg.data;
                    if (data.eventName != "boardEvent") return;
                    let isEdit = /app\.html/.test(location.href);
                    if (data.action == "newFile" && isEdit) {
                        location.href = `${window.location.origin}${appConfig["sourcePath"]}`;
                    } else if (data.action == "editFile") {
                        location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=boardEdit`;
                    }
                };
                window.addEventListener("message", messageHandle);
            }
            // let lang = new URLSearchParams(location.search.substr(1)).get("lang");
            // if(lang && ['zh', 'en', 'de', 'fr', 'jp', 'es', 'pt', 'it', 'tw', 'kr'].includes(lang)) {
            //     this.$store.commit('changeUILang', lang);
            // } else {
            //     this.$store.commit('changeUILang', appConfig.language) // 没传语言使用打包语言
            // }
            if (!this.$route.params || !this.$route.params.lang || !this.allowLangList.includes(this.$route.params.lang)) {
                this.setLang(appConfig.language, true);
            }
            this.$bus.$on("updateWorkIds", (payload) => {
                let { id, type } = payload;
                switch (type) {
                    case "like": {
                        console.log("like");
                        this.$store.commit("like", id - 0);
                        break;
                    }
                    case "dislike": {
                        console.log("dislike");
                        this.$store.commit("dislike", id - 0);

                        break;
                    }
                    case "collect": {
                        console.log("collect");
                        this.$store.commit("collect", id - 0);
                        break;
                    }
                    case "discollect": {
                        console.log("discollect");
                        this.$store.commit("disCollect", id - 0);
                        break;
                    }
                }
            });
            this.$bus.$on("closeUnCompatibilityRemind", () => {
                this.closeRemind();
            });

            // window.addEddxProcess = (oFile)=>{
            //     return new Promise((resolve, reject) => {
            //         let oFReader = new FileReader();
            //         oFReader.readAsArrayBuffer(oFile);
            //         oFReader.onload = function(oFREvent:any) {
            //             resolve(oFREvent.target.result);
            //         };
            //     })
            // }
            // window.aaaTimeout = ()=>{
            //     return new Promise((res)=>{
            //         setTimeout(()=>{
            //             res();
            //         },4000)
            //     })
            // }
            // window.startGZ = async ()=>{
            //     async function writeFile(fileHandle, contents) {
            //         // Create a writer (request permission if necessary).
            //         const writer = await fileHandle.createWriter();
            //         // Write the full length of the contents
            //         await writer.write(0, contents);
            //         // Close the file and write the contents to disk
            //         await writer.close();
            //     }
            //     const opts = {type: 'openDirectory'};
            //     const handle = await window.chooseFileSystemEntries(opts);
            //     const entries = await handle.getEntries();
            //     for await (const entry of entries) {
            //         if(entry.isFile && entry.name.endsWith(".svg")){
            //             let oFile = await entry.getFile();

            //             console.log(entry.name);
            //             // document.title= oFile.name+' - MaxOnline';
            //             // window['_view'].setDocName(oFile.name);
            //             let zip = await addEddxProcess(oFile);
            //             let TypeArray = new Uint8Array(zip);
            //             let newdata = pako.gzip(TypeArray, {
            //                 level: 9
            //             });
            //             await writeFile(entry,newdata);

            //         }
            //     }
            // }
            // window.c = [];
            // window.startC = async ()=>{
            //     const opts = {type: 'openDirectory'};
            //     const handle = await window.chooseFileSystemEntries(opts);
            //     const entries = await handle.getEntries();
            //     for await (const entry of entries) {
            //         if(entry.isFile && !entry.name.endsWith(".png")){
            //             c.push(entry.name);

            //         }
            //     }
            // }
            // window.d = [];
            // window.startD = async ()=>{
            //     const opts = {type: 'openDirectory'};
            //     const handle = await window.chooseFileSystemEntries(opts);
            //     const entries = await handle.getEntries();
            //     for await (const entry of entries) {
            //         if(entry.isFile && entry.name.endsWith(".svg")){
            //             d.push(entry.name.slice(0,-4));

            //         }
            //     }
            // }
            this.checkBuyAction();
            this.checkLog();
            // this.domain = location.hostname.indexOf("edrawmax") === -1 ? document.domain : location.hostname.slice(location.hostname.indexOf("edrawmax"))
            // document.domain = this.domain;
            window.name = "maxHome";

            // window.onstorage = e => {
            //     console.log("onstorage", e);
            //     if (e.key == "lang") {
            //         this.$store.commit("changeUILang", e.newValue);
            //     }
            // };

            let ts: any = this;
            window.onoffline = () => {
                ts.$edMessage.error({
                    content: ts.$t("offlineTip"),
                    duration: 0,
                });
                if (ts.isPC) {
                    (<any>window).$qt.jsCallOnline(0);
                }
            };
            window.ononline = () => {
                ts.$edMessage.destroy();
            };
            ts.$bus.$on("login", (type) => {
                if (this.isInclowdz) {
                    location.reload();
                    return;
                }
                if (this.isPrivate) {
                    validate()
                        .then((userInfo: any) => {
                            this.$store.commit("setState", {
                                type: "userInfo",
                                data: {
                                    oldInfo: true,
                                    islogin: true,
                                    ...userInfo,
                                },
                            });
                            this.init();
                            this.$bus.$emit("loginSucc");
                            this.$bus.$emit("loginSucc-collect");
                            this.$bus.$emit("loginSucc-files");
                            this.$bus.$emit("loginSucc-newpages");
                            this.$bus.$emit("loginSucc-recycle");
                            this.$bus.$emit("loginSucc-share");
                            this.$bus.$emit("loginSucc-store");
                            this.$bus.$emit("loginSucc-history");
                            this.$bus.$emit("loginSucc-publish");
                            this.$bus.$emit("loginSucc-shareToMe");
                            this.$bus.$emit("loginSucc-star");
                            this.$bus.$emit("loginSucc-team");
                            this.$bus.$emit("loginSucc-preview");
                            this.$bus.$emit("loginSucc-userTask");
                        })
                        .catch(() => {
                            location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                        });
                    return;
                }
                let success = (userInfo) => {
                    userInfo.oldInfo = true;
                    userInfo.islogin = true;
                    let getVIPDone = () => {
                        this.$store.commit("setState", { type: "userInfo", data: userInfo });
                        this.checkUserTag(userInfo);
                        this.init();
                        this.setLocalCookie();
                        this.$bus.$emit("loginSucc");
                        this.$bus.$emit("loginSucc-collect");
                        this.$bus.$emit("loginSucc-files");
                        this.$bus.$emit("loginSucc-newpages");
                        this.$bus.$emit("loginSucc-recycle");
                        this.$bus.$emit("loginSucc-share");
                        this.$bus.$emit("loginSucc-store");
                        this.$bus.$emit("loginSucc-history");
                        this.$bus.$emit("loginSucc-publish");
                        this.$bus.$emit("loginSucc-shareToMe");
                        this.$bus.$emit("loginSucc-star");
                        this.$bus.$emit("loginSucc-team");
                        this.$bus.$emit("loginSucc-preview");
                        this.$bus.$emit("loginSucc-userTask");
                    };
                    this.$edApi
                        .getSubscription({ id: userInfo.user_id, token: userInfo.token })
                        .then((expObj) => {
                            console.log(expObj);
                            if (expObj) {
                                let { now, online_exp: onlineExp, exp } = expObj,
                                    curStamp = new Date(now).getTime(),
                                    expStamp = new Date(this.isPC ? exp : onlineExp).getTime();

                                if (expStamp > curStamp) {
                                    this.$store.commit("toPublicStatus", { type: "vip", data: 1 });
                                    if (!app.hasOwnProperty("$v_")) {
                                        Object.defineProperty(app, "$v_", { value: 1 });
                                    }
                                } else {
                                    this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                                    this.getPurchaseBubble();
                                    if (!app.hasOwnProperty("$v_")) {
                                        Object.defineProperty(app, "$v_", { value: 0 });
                                    }
                                }
                            } else {
                                this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                                this.getPurchaseBubble();
                                if (!app.hasOwnProperty("$v_")) {
                                    Object.defineProperty(app, "$v_", { value: 0 });
                                }
                            }
                            getVIPDone();
                            this.retryCount = 0;
                            this.delay = 0;
                        })
                        .catch((err) => {
                            console.log(err);
                            console.log(err.response);
                            this.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                            if (!app.hasOwnProperty("$v_")) {
                                Object.defineProperty(app, "$v_", { value: 0 });
                            }
                            getVIPDone();
                        });
                };
                const loginSuccess = (userInfo) => {
                    success(userInfo);

                    // 从社区模板登录成功后，增加埋点
                    if (["Store", "NewPage"].includes(ts.$route.name)) {
                        this.sensors.track("templateSignInSuccess", {
                            Catalogues: "Templates",
                            platform: this.isPC ? "desktop" : "online",
                            page: "templateCommunity",
                        });
                    }
                };
                const redircect = () => {
                    if (appConfig.isBuild && appConfig.loginRedirect && !this.isPC && !this.isTeamsApp) {
                        location.href = `${location.origin}?auto=1`;
                    }
                };
                let utm_term = this.utm_term ? `4-${this.utm_term}` : "";
                let loginParams = {
                    pid: this.appPid,
                    seo_source: utm_term,
                    refreshMode: 1,
                };
                $edAuth
                    .checkLocalCookie(!this.isPC, loginParams)
                    .then((userInfo: any) => {
                        delayFunc(this.delay).then(() => {
                            success(userInfo);
                        });
                        if (this.retryCount < 5) {
                            this.delay = fibonacciDelay(this.retryCount);
                            this.retryCount++;
                        }
                    })
                    .catch(() => {
                        this.retryCount = 0;
                        this.delay = 0;
                        if (type == "token expire") {
                            $edAuth.auth(
                                loginSuccess,
                                () => {
                                    redircect();
                                    $edAuth.show();
                                },
                                loginParams
                            );
                        } else {
                            $edAuth.auth(loginSuccess, () => {}, loginParams);
                        }
                    });
            });
            ts.$bus.$on("inclowdLogin", () => {
                this.initInclowdzEvent();
            });
            ts.$bus.$on("reg", () => {
                $edAuth.showSignUp();
            });
            ts.$bus.$on("logout", () => {
                if (this.isPrivate) {
                    logout();
                    return;
                }
                if (appConfig.isBuild && appConfig.loginRedirect && !this.internal && !this.isTeamsApp) {
                    let url = location.href.toString().replace(/\?.*$/, "");
                    let auto = ~location.search.indexOf("?") ? "&notAuto=1" : "?notAuto=1";
                    history.replaceState(null, document.title, url + location.search + auto);
                }
                $edAuth.logout().then(() => {
                    if (this.isTeamsApp) {
                        location.reload();
                        return;
                    }
                    location.href = location.origin;
                });
            });
            ts.$bus.$on("openCollectWorkById", (workId) => {
                let openPreview = () => {
                    let para = JSON.parse(JSON.stringify(this.params));
                    this.$edApi.getLikeAndCollectWorks(Object.assign(para, { type: "collect" })).then((data) => {
                        data = data.filter((item) => {
                            return item.url != null && item.id == workId;
                        });
                        if (data.length > 0) {
                            this.$store.commit("toActiveWork", data[0]);
                            this.$store.commit("toTplCenter", {
                                name: "previewContext",
                                data: "center",
                            });
                        }
                    });
                    // this.$edApi.getWorkInfo({
                    //     id: 0,
                    //     workId,
                    //     platform: this.$store.state.publicStore.runPlatform
                    // })
                    // .then(data => {
                    //     console.log("get workinfo success");

                    //     this.$store.commit("toActiveWork", data);
                    //     this.$store.commit("toTplCenter", {
                    //         name: "previewContext",
                    //         data: "center"
                    //     });
                    // });
                };
                if (this.$router["name"] != "Collect") {
                    this.$bus.$emit("changeSlide", 4);
                    this.$nextTick(() => {
                        openPreview();
                    });
                } else {
                    openPreview();
                }
            });

            let action = new URLSearchParams(location.search.substr(1)).get("action");
            let isOpenMyColud = new URLSearchParams(location.search.substr(1)).get("left");
            if (isOpenMyColud === "false") {
                this.$store.commit("setState", {
                    type: "isOpenMyColud",
                    data: true,
                });
            }
            if (action) {
                this.$store.commit("setState", {
                    type: "pcSaveInput",
                    data: action,
                });
            }
            document.addEventListener("visibilitychange", () => {
                if (this.isPlugin || this.isTeamsApp) return;
                let state = document.visibilityState;
                if (state == "visible") {
                    this.$bus.$emit("checkVipFirst");
                    if (this.isInclowdz || this.isPrivate) return;
                    let success = (userInfo: any) => {
                        userInfo.oldInfo = true;
                        userInfo.islogin = true;
                        this.$store.commit("setState", { type: "userInfo", data: userInfo });
                        this.$store.dispatch("getUserInfo");
                        this.setLocalCookie();
                        !this.internal && this.updateVipStatus(); // 海外版本主动检查vip刷新状态
                    };
                    // 去掉，因为会影响桌面端的另存为功能
                    let fail = () => {
                        if (appConfig.isBuild && appConfig.loginRedirect) {
                            location.href = `${location.origin}?auto=1`;
                        }
                        $edAuth.show();
                    };
                    let utm_term = this.utm_term ? `4-${this.utm_term}` : "";
                    let loginParams = {
                        pid: this.appPid,
                        seo_source: utm_term,
                        refreshMode: 1,
                    };
                    $edAuth
                        .checkLocalCookie(!this.isPC, loginParams)
                        .then((userInfo: any) => {
                            success(userInfo);
                        })
                        .catch(() => {
                            if (this.isPC) return;
                            // $edAuth.auth(success, fail, loginParams);
                        });
                }
            });
        }
        getThemeColor() {
            let storage = localStorage;
            let theme = storage.getItem("themeColor");
            let index = theme || 0;
            let colorList = ["#017fff", "#3a4275", "#4f5359"];
            let hoverList = ["#006adf", "#303970", "#434850"];
            let activeList = ["#0065d4", "#262f67", "#373c44"];
            let menuHoverList = ["#f5f7fc", "#ebecf1", "#ebecf1"];
            let menuActiveList = ["#F1F3FB", "#e1e3ea", "#e1e3ea"];
            let loginList = [
                "#fff",
                "linear-gradient(90deg, #B7C1FF 0%, #DCE0FF 100%)",
                "linear-gradient(270deg, rgba(221, 225, 231, 0.6) 0.93%, #DDDEE1 98.15%)",
            ];
            let loginHoverList = [
                "rgba(255,255,255,0.8)",
                "linear-gradient(90deg, #D4DAFC 0%, #E9EBFC 100%)",
                "linear-gradient(270deg, rgba(221, 225, 231, 0.6) 0.93%, #DDE1E7 98.15%)",
            ];
            let downloadList = ["#0977EA", "#3A4275", "#4F5359"];
            let downloadHoverList = ["#006ADF", "#1E265C", "#2E3339"];
            document.body.style.setProperty("--themeColor", colorList[index]);
            document.body.style.setProperty("--themeHover", hoverList[index]);
            document.body.style.setProperty("--themeActive", activeList[index]);
            document.body.style.setProperty("--menuHover", menuHoverList[index]);
            document.body.style.setProperty("--menuActive", menuActiveList[index]);
            document.body.style.setProperty("--loginBg", loginList[index]);
            document.body.style.setProperty("--loginBgHover", loginHoverList[index]);
            document.body.style.setProperty("--downloadColor", downloadList[index]);
            document.body.style.setProperty("--downloadHover", downloadHoverList[index]);
            this.$store.commit("setState", {
                type: "themeIndex",
                data: index,
            });

            if (this.isPC) {
                // 旧客户端的chrome61版本不支持 (?<=...) 后行断言，此处不能使用 /(?<=[&|?])theme=[^&]*/ 这种正则
                const url = location.href.replace(/\&theme\=[^\&]*/, "&theme=" + index).replace(/\?theme\=[^\&]*/, "?theme=" + index);
                history.replaceState(history.state, "", url);
                if (this.$isBiggerVersion("11.5.0")) {
                    this.$store.commit("setState", { type: "isPCDarkMode", data: index });
                }
            }
            let sliderColor = this.isPCDarkMode == 2 ? "#343437" : "#FFFFFF";
            let fitWidth = 180;
            if (this.pcLang == "de") {
                fitWidth = 190;
            } else if (this.pcLang == "es" || this.pcLang == "pt") {
                fitWidth = 240;
            }
            this.$store.commit("setState", {
                type: "pcSliderFitWidth",
                data: fitWidth,
            });
            (<any>window).$qt && (<any>window).$qt.jsCallUpdateLeft && (<any>window).$qt.jsCallUpdateLeft(fitWidth, sliderColor);
            this.$bus.$emit("setThemeMode", this.isPCDarkMode); // for plugin EDModal
        }
        setThemeColor(e) {
            if (e.key === "themeColor") {
                this.getThemeColor();
            }
        }
        get showMsg() {
            return this.$store.state.showMsg;
        }
        @Provide()
        showMessage = (data) => {
            let checkAvoidList = () => {
                let store = localStorage;
                let list = JSON.parse(store.getItem("msgAvoidList")) || [];
                if (list.includes(data.avoidTitle)) {
                    return true;
                }
                return false;
            };
            let msg = {
                sponsor: data["sponsor"] || "", // 动作发起者，需要监听ok cancel事件时使用, 监听$bus msgOperation 事件
                uniqueListenr: data["uniqueListenr"] || false, // 动作监听器是否唯一, 除非是v-if控制的模块，否则都需要唯一监听事件，防止off误删
                title: data["title"] || "",
                type: data["type"] || 0, // 弹窗类型
                time: data["time"] || 3, // 弹窗消失时间
                imgType: data["imgType"] || 0, // 弹窗图片 0 提示 1 成功 2 失败
                content: data["content"] || "", // 提示主题内容
                extraCon: data["extraCon"] || "", // 额外提示
                temp: data["temp"], // 暂存部分数据，用于传递通信所需的id等数值
                avoid: data["avoid"] || false, // 开启不再提醒
                avoidTitle: data["avoidTitle"] || "", // 不再提醒索引
                btnType: data["btnType"] || 0, // 0 确定 取消，1 是 否，默认值为 0
                msgClass: data["msgClass"] || "",
            };
            this.$store.commit("setState", {
                type: "message",
                data: msg,
            });

            if (data.avoid) {
                // 开启不再提醒且处于不再提醒名单时，不显示弹窗
                let flag = checkAvoidList();
                if (flag) {
                    return;
                }
            }
            this.$store.commit("setState", {
                type: "showMsg",
                data: true,
            });
        };
        toBuy() {
            if (!this.$validateLogin()) return;
            (<any>window).$qt.jsCallOpenWebBuyDialog
                ? (<any>window).$qt.jsCallOpenWebBuyDialog("")
                : (<any>window).$qt.jsCallOpenUrl("https://www.edrawsoft.cn/order/buy-activity-2021-618.html");
            this.closeBuy();
        }
        closeBuy() {
            this.$store.commit("setState", {
                type: "buy618",
                data: false,
            });
            localStorage.setItem("buy618", "1");
        }
        initReleases(isNew: boolean) {
            this.$edApi
                .getUptLog()
                .then((data) => {
                    const { content, version } = data;
                    const localVersion = localStorage.getItem("releasesVersion");
                    this.releasesContent = content;
                    this.releasesVersion = version;
                    if (isNew) return;
                    if (String(version) === localVersion) return;
                    if (this.callback) {
                        localStorage.setItem("releasesVersion", this.releasesVersion);
                        return;
                    }
                    if (this.$route.name === "new" || this.$route.name === "/") {
                        this.showReleasesModal = true;
                        localStorage.setItem("releasesVersion", this.releasesVersion);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        callback = false;
        closeReleases() {
            if (!this.showReleasesModal && this.releasesVersion) {
                localStorage.setItem("releasesVersion", this.releasesVersion);
            }

            if (!this.showReleasesModal && !this.releasesVersion) {
                this.callback = true;
            }
        }
        videoModalChange() {
            if (!this.showVideoModal && this.$store.state.videoTitle === "入门视频") {
                this.$store.state.isNewUserVideo = true;
            }
        }
        // 内嵌国外客服
        initForeignCustomerService() {
            if (this.internal) return;
            const script = document.createElement("script");
            script.src = "https://crm-static.wondershare.cc/chatbot/latest/assets/snippet.js?key=83e95267-c410-e755-b33f-cd4f074ce1b2";
            script.id = "ws-snippet";
            window["___crm40_hide_chatbot_bubble_mode___"] = true;
            document.body.appendChild(script);
        }
        initBacklistener() {
            window.addEventListener("message", (e) => {
                let data = e.data;
                if (data.action == "backHome") {
                    let name = "maxHome" + Math.round(Math.random() * 10000);
                    window.name = name;
                    (<Window>e.source)?.postMessage(
                        {
                            action: "backHome",
                            name: name,
                        },
                        "*"
                    );
                }
            });
        }
        showPromodal = false;
        promodalPage = 1;
        promodalType = 0;
        togglePromodal(data = false) {
            if (data) {
                this.sensors.track("popNewUpgradePlanTip", {
                    upgrade_trigger: this.$store.state.publicStore.upgradeTrigger,
                    ab_test: this.userInfo?.user_id % 2 ? "b" : "a",
                });
            }
            this.showPromodal = data;
        }

        // fix BUG: p122_6478，关闭登录弹框时，如果还存在用户信息残留，则刷新页面
        edrawAuthClose() {
            if (this.userInfo?.token || this.userInfo?.user_id) {
                location.reload();
            }
        }

        getPurchaseBubble() {
            this.$edApi
                .getPurchaseBubble({
                    config_key: "max_purchase_bubble",
                    v: this.appVersion,
                })
                .then((res) => {
                    if (res.data.status == "success" && !!res.data.data.first) {
                        this.$store.commit("changePurchaseBubble", res.data.data.first);
                    } else {
                        this.$store.commit("changePurchaseBubble", "");
                    }
                });
        }

        get showPreviewModal() {
            return this.$store.state.showPreviewModal;
        }

        showUserTag = false;
        checkUserTag(userInfo) {
            this.showUserTag = false;
            return new Promise((rs, rj) => {
                this.$edApi.getUserTag({ id: userInfo.user_id, token: userInfo.token }).then((res) => {
                    if (res.data.data == null) {
                        this.showUserTag = true;
                    } else {
                        let data = res.data.data;
                        if (data) {
                            let identityId = data.identity_id;
                            let industryId = data.industry_id;
                            let userJob = [12, 24].includes(identityId) && data.identity_extra ? data.identity_extra : data.identity.name_cn;
                            let userIndustry = [12, 24].includes(industryId) && data.industry_extra ? data.industry_extra : data.industry.name_cn;

                            this.sensors.registerPage(
                                identityId == 8
                                    ? {
                                          user_job: userJob,
                                          user_major: userIndustry,
                                      }
                                    : {
                                          user_job: userJob,
                                          user_industry: userIndustry,
                                      }
                            );
                        }
                        rs(null);
                    }
                });
            });
        }

        showCollectTips = false;
        checkCollectTips() {
            if (this.isPC) return;
            let local = localStorage.getItem("collectTips");
            if (local == "1") {
                this.showCollectTips = false;
            } else if (local) {
                this.showCollectTips = true;
                localStorage.setItem("collectTips", "1");
                this.sensors.track("bookmarkTips__popup", {
                    Catalogues: "bookmarkWebTips",
                });
            } else {
                localStorage.setItem("collectTips", "2");
            }
        }
        closeCollectModal() {
            this.showCollectTips = false;
        }

        mounted() {
            this.initBacklistener();
            this.initForeignCustomerService();
            this.isBrowser();
            this.getThemeColor();
            this.checkCollectTips();
            !this.isPC && window.addEventListener("storage", this.setThemeColor);
            if (this.isPlugin) {
                window.parent.postMessage(
                    {
                        // 页面加载完成
                        eventName: "edrawmaxEvent",
                        action: "loaded",
                    },
                    "*"
                );
            }
            if (this.isPC) {
                this.$bus.$on("themeChange", () => {
                    this.getThemeColor();
                });
            }
            this.$store.commit("initLayout");
            this.internal && !this.isWorkwx && this.$store.dispatch("getMedalIds");
            let homeContainer = document.querySelector(".home-container");
            let isMac = navigator.userAgent.indexOf("Mac") !== -1;
            // 禁止Ctrl 滚轮缩放事件，WheelDelta +/-120 表示上下滚动，火狐是 detail -/+ 3。
            let zoomFunc = (e: WheelEvent) => {
                // Mac 触控板双指方向不一致时，ctrlKey为 true
                let ctrlkey = isMac ? e.metaKey || e.ctrlKey : e.ctrlKey;
                if (ctrlkey) {
                    e.preventDefault();
                }
            };
            this.$bus.$on("showConfirmModal", (title = "", content) => {
                this.$edModal.show({
                    title: title || this.$t("remind"),
                    content,
                    confirmText: this.$t("okText"),
                    useDark: this.isPCDarkMode,
                    isPC: this.isPC,
                    noMask: this.isPC,
                });
            });
            this.$bus.$on("showCloudSpaceVipTips", () => {
                this.$edModal.show({
                    title: this.$t("remind"),
                    content: this.$t("cloudVipSpaceTips"),
                    confirmText: this.$t("okText"),
                    useDark: this.isPCDarkMode,
                    isPC: this.isPC,
                    noMask: this.isPC,
                });
            });

            window.addEventListener("DOMMouseScroll", zoomFunc, { passive: false }); //firefox;
            window.addEventListener("wheel", zoomFunc, { passive: false }); //IE/Opera/Chrome/Safari
            window.addEventListener(
                "keydown",
                function (event) {
                    // event.which 是 event.keyCode 和 event.charCode 的标准化
                    let ctrlkey = isMac ? event.metaKey : event.ctrlKey;
                    if (
                        ctrlkey &&
                        (event.which === 61 ||
                            event.which === 107 ||
                            event.which === 173 ||
                            event.which === 109 ||
                            event.which === 187 ||
                            event.which === 189)
                    ) {
                        event.preventDefault();
                    }
                },
                false
            );
            let ts = this;

            this.$bus.$on("starterGuide", () => {
                if (appConfig.language !== "zh") return;
                let p = 3;
                if (ts.$route.name === "NewPage") p = 4;
                this.$nextTick(() => {
                    let tour = this.$shepherd({
                        useModalOverlay: true,
                        defaultStepOptions: {
                            classes: "new-guide",
                            highlightClass: "no-pointer",
                            popperOptions: {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [0, 12],
                                        },
                                    },
                                ],
                            },
                        },
                    });
                    tour.on("complete", () => {
                        if (ts.$store.state.starter !== null) {
                            if (ts.userInfo) {
                                let params = {
                                    id: ts.userInfo.user_id,
                                    token: ts.userInfo.token,
                                    obj: { starter: ts.$store.state.starter | 1 },
                                };
                                ts.$edApi.updateUserPrefer(params);
                            }
                        }
                    });

                    tour.addSteps([
                        {
                            classes: "guide-left",
                            attachTo: { element: "#logoBox", on: "bottom" },
                            text: `<div>向导提示: 点击logo图标即可返回首页</div>
                            <div style="text-align:right">(点击任意区域继续)</div>`,
                            advanceOn: {
                                selector: ".shepherd-modal-overlay-container",
                                event: "click",
                            },
                            popperOptions: {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [0, 10],
                                        },
                                    },
                                ],
                            },
                            buttons: [
                                {
                                    disabled: true,
                                    text: "",
                                },
                            ],
                        },
                        {
                            classes: "guide-left",
                            attachTo: { element: ".myDocSlide", on: "bottom" },
                            text: `我的工作台：您保存的文件，文件夹及分享的文件都在工作台中`,
                            advanceOn: {
                                selector: ".shepherd-modal-overlay-container",
                                event: "click",
                            },
                            buttons: [
                                {
                                    disabled: true,
                                    text: "",
                                },
                            ],
                        },
                        {
                            classes: "guide-right",
                            attachTo: { element: "#topBarBox", on: "bottom" },
                            text: `个人账号: 点击可以查看个人用户中心，信息设置，软件使用信息等`,
                            advanceOn: {
                                selector: ".shepherd-modal-overlay-container",
                                event: "click",
                            },
                            buttons: [
                                {
                                    disabled: true,
                                    text: "",
                                },
                            ],
                        },
                    ]);
                    if (p === 4) {
                        tour.addStep({
                            classes: "guide-right guide-spec",
                            attachTo: { element: "#workExpandBox", on: "bottom" },
                            text: `展开分类: 可快速查找所需要绘制的绘图类型及绘图模板`,
                            advanceOn: {
                                selector: ".shepherd-modal-overlay-container",
                                event: "click",
                            },
                            buttons: [
                                {
                                    disabled: true,
                                    text: "",
                                },
                            ],
                        });
                    }
                    for (let i = 0; i < tour.steps.length; i++) {
                        tour.steps[i].on("show", function () {
                            this.getElement().addEventListener("click", () => {
                                tour.next();
                            });
                        });
                    }

                    tour.start();
                });
            });
            this.$bus.$on("pcLoginEvenvt", () => {
                console.log("pclogggginnnnnnnnnnnnnnn");
                this.afterLogined();
            });
            this.$bus.$on("togglePromodal", (data, type = 0, page = 1) => {
                this.promodalType = type;
                this.promodalPage = page;
                this.togglePromodal(data);
            });

            if (!this.isPC && $edAuth.on) {
                $edAuth.on("edrawAuthClose", this.edrawAuthClose);
            }
            $edAuth.on && $edAuth.on("edrawAuthSignup", this.trackSignUp);

            this.$bus.$on("closeUserTag", () => {
                this.checkUserTag(this.userInfo).then(() => {
                    this.checkProModal();
                });
                this.$bus.$off("closeUserTag");
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("themeChange");
            ts.$bus.$off("login");
            ts.$bus.$off("closeLogin");
            ts.$bus.$off("openFilesConfirm");
            ts.$bus.$off("updateWorkIds");
            if ($edAuth.off) {
                $edAuth.off("edrawAuthClose", this.edrawAuthClose);
                $edAuth.off("edrawAuthSignup", this.trackSignUp);
            }
        }
    }
</script>

<style>
    .vertical-center-modal {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vertical-center-modal .ivu-modal {
        top: 0;
    }
    .position-relative {
        position: relative;
    }
    .adbox-alert .close-icons {
        position: absolute;
        right: 24px;
        top: 24px;
        cursor: pointer;
    }
    .buy-btn {
        position: absolute;
        right: 12%;
        top: 56%;
        cursor: pointer;
    }

    body,
    html {
        height: 100%;
    }
    .app {
    }
    body {
        --themeColor: #2a82eb;
        --themeHover: #2163b3;
        --themeActive: #0065d4;
        --menuHover: #f5f7fc;
        --menuActive: #f1f3fb;
        --loginBg: #fff;
        --loginBgHover: rgba(255, 255, 255, 0.8);
        --downloadColor: #0977ea;
        --downloadHover: #006adf;
        --svg-color-black: #000;
        --svg-color-gray-75: #757575;
        font-family: "Apple", "Microsoft YaHei", "Noto Sans SC", "Noto Sans", "Avenir", Helvetica, Arial, sans-serif !important;
    }
    .ivu-tabs-nav .ivu-tabs-tab-active {
        color: var(--themeColor) !important;
    }
    .ivu-tabs-ink-bar {
        background-color: var(--themeColor) !important;
    }
    .no-pointer {
        pointer-events: none !important;
    }
    .lang-box {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 11;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .empty-tip {
        margin-top: 50px;
        padding-right: 60px;
        font-size: 28px;
        color: #888;
        text-align: center;
    }
    @media (max-width: 1260px) {
        /* .home-container .new-page-container .content .draw-type-box .draw-type-item{
        width: 140px;
        height: 100px;
    }
    .home-container .new-page-container .content .draw-type-box .draw-type-item .img{
        margin: 14px 0 6px;
    } */
        /* .home-container .new-page-container .content .example-box .example-item-add{
        width: 180px;
        height: 120px;
    }
    .home-container .new-page-container .content .example-box .example-item{
        width: 180px;
        height: 120px;
    } */
        .home-container .option-container .option-sidebar div {
            width: 200px;
        }
    }
</style>
<style lang="stylus">
    .fileopen-mask
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        z-index 999
        display flex
        justify-content center
        align-items center
        user-select none
        img
            width 300px
    @keyframes guidePointer {
        0% {
            transform: scale(1)
        }
        50% {
            transform: scale(1.2)
        }
        100% {
            transform: scale(1)
        }
    }
    .open-files-box
        position absolute
        left 0
        width 0
        width 100vw
        height 100vh
        z-index 2
        .open-files-mask
            modal-mask()
            z-index unset
        .open-files-dialog
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            width 416px
            padding 20px
            padding-bottom 80px
            background #fff
            box-shadow 0px 0px 4px rgba(0, 0, 0, 0.15)
            border-radius 5px
            p
                color #424242
                font-size 14px
            .open-files-btn
                position absolute
                right 20px
                bottom 20px
                display flex
                div
                    height 32px
                    min-width 80px
                    padding 6px 10px
                    font-size 12px
                    border-radius 4px
                    border 1px solid transparent
                    text-align center
                    user-select none
                    cursor pointer
                    transition all .2s linear
                    &:first-child
                        margin-right 10px
                .open-files-confirm
                    background #007fff
                    color #fff
                    &:hover
                        background #2D8CF0
                .open-files-cancel
                    background #fff
                    color #666
                    border-color #e4e4e4
                    &:hover
                        color #57A3F3
                        border-color #57A3F3
    .shepherd-modal-is-visible
        opacity: 0 !important
    .shepherd-modal-overlay-container
        pointer-events: auto !important
    .guide-left
        left 50px !important
        .shepherd-arrow
            left -50px !important
        .shepherd-footer
            top -50px
            left 48px
    .guide-spec
        .shepherd-footer
            top -38px !important
            right 72px !important
    .guide-right
        .shepherd-arrow
            right 50px !important
            transform translate(300px, 0px) !important
        .shepherd-footer
            top -50px
            right 30px
            left auto !important
            transform none !important
    .new-guide
        font-family: 'Noto Sans', 'Noto Sans SC',   'Avenir', Helvetica, Arial, sans-serif;
        width auto !important
        max-width 350px !important
        border 1px solid #FFBF00
        box-shadow 0px 2px 5px rgba(199, 149, 0, 0.6) !important
        .shepherd-arrow:before
            background-color white !important
            border-top 1px solid #FFBF00
            border-left 1px solid #FFBF00
        .shepherd-content
            position relative
            border-radius 10px
            .shepherd-text
                font-size 14px !important
            .shepherd-header
                height 40px
                background white !important
                border-top-left-radius 10px
                border-top-right-radius 10px
                border-bottom 1px solid #e0e0e0
                padding 0 !important
                text-indent 16px
                >h3
                    display block !important
                    font-size 16px
                    .subTitle
                        font-weight bold
            .shepherd-footer
                padding 0
                position absolute
                .shepherd-button-secondary
                    margin-right auto
                    color #3288E6
                    font-size 12px
                    background initial
                    outline none
                    &:not(:disabled):hover
                        background initial !important
                        color #3288E6 !important
                .shepherd-button
                    animation-name guidePointer
                    animation-duration 1s
                    animation-iteration-count infinite
                    border-radius 50%
                    background-color #FFBF00
                    opacity 0.7
                    filter blur(2px)
                    width 24px
                    height 24px
                    padding 0
                    cursor default !important
    .releases-modal{
        display flex
        align-items center
        &.internal .ivu-modal-body{
            padding 0px 20px
        }
        .ivu-modal-body{
          padding 0px 0px
        }
    }
     .releases-content{
        width: calc(100% + 20px);
        padding: 20px 16px 20px 0;
        max-height: 610px;
        overflow: auto;
        @media screen and (max-height: 700px) {
            max-height: 400px
        }
        img{
            max-width: 100%;
        }
        &::-webkit-scrollbar {
           width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
        }
        &::-webkit-scrollbar-track {
            border-radius: 10px;
        }
     }
</style>
<i18n>
{
  "zh": {
    "function2": "新功能",
    "remind": "提示",
    "chrome1": "检测到当前浏览器兼容性较差，可能导致某些功能无法使用。",
    "chrome2": "为了您有更好的使用体验，我们建议您使用谷歌浏览器",
    "download": "下载谷歌浏览器",
    "offlineTip": "无网络连接，请检查您的网络",
    "openFilesTips": "批量打开文件数量已达上限（20个），点击“继续”您将仅打开选中的前20个文件，是否继续打开",
    "cloudVipSpaceTips": "无法使用此功能，因为可用的云空间不足，请清理后继续使用。",
    "okText": "确定",
    "confirm": "继续",
    "cancel": "取消"
  },
  "en": {
    "function2": "What's New",
    "remind": "Reminder",
    "chrome1": "Poor browser compatibility is detected, and part of the functionality may not be available.",
    "chrome2": "For a better user experience, we recommend use Google Chrome as your default browser.",
    "download": "Download Google Chrome",
    "offlineTip": "No Internet, please check your network",
    "openFilesTips": "You have reached the batch open limitations (20 files). Click \"Continue\", it will open the first 20 files you've chosen. Do you want to continue?",
    "cloudVipSpaceTips": "This function cannot be used because there is not enough cloud storage available. You can manage your storage in Cloud Documents.",
    "okText": "Confirm",
    "confirm": "Continue",
    "cancel": "No"
  },
  "fr": {
    "function2": "Quoi de neuf",
    "remind": "rappeler",
    "chrome1": "Il est détecté que le navigateur actuel a une mauvaise compatibilité et peut entraîner l'indisponibilité de certaines fonctions.",
    "chrome2": "Afin d'avoir une meilleure expérience utilisateur, nous vous recommandons d'utiliser Google Chrome",
    "download": "Téléchargez Google Chrome",
    "offlineTip": "Pas de connexion Internet, veuillez vérifier votre réseau",
    "openFilesTips": "Vous avez atteint les limites d'ouverture des lots (20 fichiers). Cliquez sur \"Continuer\", cela ouvrira les 20 premiers fichiers que vous avez choisis. Voulez-vous continuer?",
    "okText": "Confirmer",
    "confirm": "continuer",
    "cancel": "Annuler"
  },
  "de": {
    "function2": "Was neu ist",
    "remind": "Hinweis ",
    "chrome1": "Schlechte Browser-Kompatibilität erkannt wird, und ein Teil der Funktionalität kann nicht verfügbar sein.",
    "chrome2": "Für eine bessere Benutzererfahrung empfehlen wir, Google Chrome als Standardbrowser zu verwenden.",
    "download": "Google Chrome Herunterladen",
    "offlineTip": "Kein Internet, überprüfen Sie bitte Ihr Netzwerk",
    "openFilesTips": "Die Anzahl der in Stapeln geöffneten Dateien hat die Obergrenze (20) erreicht. Klicken Sie auf \"Weiter\" und Sie können die ersten 20 ausgewählten Dateien öffnen. Möchten Sie das weitgehend öffnen?",
    "okText": "Sichern",
    "confirm": "Fortsetzen",
    "cancel": "Abbrechen"
  },
  "jp": {
    "function2": "新機能",
    "remind": "通知",
    "chrome1": "現在のブラウザーの互換性が低いことが検出されたため、一部の機能が使用できなくなる可能性があります。",
    "chrome2": "ユーザーエクスペリエンスを向上させるために、Google Chromeを使用することをお勧めします",
    "download": "Chrome をダウンロード",
    "offlineTip": "インターネット接続がありません。ネットワークを確認してください",
    "openFilesTips": "一括で開くファイルの数が上限（20ファイル）に達しました。「続行」をクリックすると、選択した最初の20ファイルが開きます。続行しますか？",
    "okText": "OK",
    "confirm": "続行",
    "cancel": "キャンセル"
  },
  "es": {
    "function2": "Qué hay de nuevo",
    "remind": "Recordatorio",
    "chrome1": "Se detecta una mala compatibilidad del navegador y es posible que algunas funciones no esten disponibles.",
    "chrome2": "Para una mejor experiencia de usuario, recomendamos usar Google Chrome como su navegador predeterminado.",
    "download": "Descargar Google Chrome",
    "offlineTip": "No hay internet, por favor revise su red",
    "openFilesTips": "El número de archivos abiertos por lotes ha alcanzado el límite superior (20)，Haz clic en \"Continuar\", se abrirán los primeros 20 archivos que haya elegido. ¿Quieres continuar?",
    "okText": "OK",
    "confirm": "Continuar",
    "cancel": "Cancelar"
  },
  "pt": {
    "function2": "O que há de novo",
    "remind": "Alerta",
    "chrome1": "Detectada baixa compatibilidade com o browser, e parte da funcionalidade pode não estar disponível.",
    "chrome2": "Para uma melhor experiência para o usuário, recomendamos o uso do Google Chrome como o seu browser padrão.",
    "download": "Descarregar o Google Chrome",
    "offlineTip": "Sem Internet, por favor, verificar a sua rede",
    "openFilesTips": "Você atingiu as limitações do lote aberto (20 arquivos). Clique em \"Continuar\", ele abrirá os 20 primeiros arquivos que você escolheu. Você quer continuar?",
    "okText": "OK",
    "confirm": "continuar",
    "cancel": "Cancelar"
  },
  "it": {
    "function2": "Cosa nuova c'è ",
    "remind": "Promemoria",
    "chrome1": "È stata rilevata scarsa compatibilità browser; alcune delle funzioni potrebbero non essere disponibili.",
    "chrome2": "Per un'esperienza ottimale, consigliamo di utilizzare Google Chrome come browser predefinito.",
    "download": "Scarica Google Chrome",
    "offlineTip": "Nessuna connessione. Si prega di controllare la rete Internet.",
    "openFilesTips": "Hai raggiunto i limiti di apertura batch (20 file). Se fai clic su “Continua”, si apriranno i primi 20 file che hai scelto. Vuoi continuare?",
    "okText": "OK",
    "confirm": "continua",
    "cancel": "Annulla"
  },
  "tw": {
    "function2": "新功能",
    "remind": "提示",
    "chrome1": "檢測到當前瀏覽器兼容性較差，可能導致某些功能無法使用。",
    "chrome2": "為了您有更好的使用體驗，我們建議您使用谷歌瀏覽器",
    "download": "下載谷歌瀏覽器",
    "offlineTip": "無網絡連接，請檢查您的網絡",
    "openFilesTips": "批量打開檔案數量已達上限（20個），點擊「繼續」您將僅打開選中的前20個檔案，是否繼續打開?",
    "okText": "確定",
    "confirm": "繼續",
    "cancel": "取消"
  },
  "kr": {
    "function2": "업데이트 정보",
    "remind": "알림",
    "chrome1": "현재 브라우저 호환성이 좋지 않아 일부 기능을 사용하지 못할 수 있습니다.",
    "chrome2": "더 나은 경험을 위해 Google 크롬을 사용하는 것을 추천합니다.",
    "download": "구글 크롭 다운로드하기",
    "offlineTip": "네트워크 연결이 없습니다. 네트워크를 확인하십시오.",
    "openFilesTips": "동시에 열 수 있는 파일 수량 제한 (20 개 파일)에 도달했습니다. \"계속하기\"를 클릭하면 선택한 처음 20 개 파일만 열립니다.",
    "okText": "확인",
    "confirm": "계속하기",
    "cancel": "취소"
  },
  "id": {
    "function2": "Yang Baru",
    "remind": "Pengingat",
    "chrome1": "Kompatibilitas browser terdeteksi buruk, dan sebagian fungsi mungkin tidak tersedia.",
    "chrome2": "Untuk pengalaman pengguna yang lebih baik, sebaiknya gunakan Google Chrome sebagai browser default Anda.",
    "download": "Unduh Google Chrome",
    "offlineTip": "Tidak ada internet. Periksa jaringan Anda",
    "openFilesTips": "Anda telah mencapai batas buka file massal (20 file). Klik \"Lanjutkan\" untuk membuka 20 file pertama yang Anda pilih. Ingin melanjutkan?",
    "okText": "确定",
    "confirm": "Lanjutkan",
    "cancel": "Tidak"
  }
}
</i18n>
